import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiAccountKey } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';

import { ROLES } from '../../keys';
import { rolesListRoute } from '../../routes';

export interface RoleSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
}

const RoleSideNavigation = ({ isAllowed, ...restOfProps }: RoleSideNavigationProps) => {
    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            label={translateKey(ROLES.ROLES)}
            icon={mdiAccountKey}
            route={rolesListRoute}
        />
    );
};

RoleSideNavigation.displayName = 'SideNavigationItem';

export { RoleSideNavigation };
